import React from 'react';

import theme from '@styles/theme';

const viewport = Component => {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        width: 0,
        height: 0,
      };
    }

    componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    render() {
      const { width, height } = this.state;
      const mobileView = width < Number(theme.screen.md.slice(0, -2));

      return (
        <Component viewport={{ width, height, mobileView }} {...this.props} />
      );
    }
  };
};

export default viewport;
